export class MaritalStatus {

  maritalStatus: string;
  maritalStatusName: string;
  spouseName: string;
  spouseCpf: string;
  foreignSpouse: boolean;
  isCompleted?: boolean;
  editData: [];
  firstEdit = [];
}
